import Breadcrumb from 'Components/UI/Breadcrumb';
import { Container } from "reactstrap";
import BookingForm from './Booking Form/Booking';
import { useEffect } from 'react';
import { clearCart, setEditMode } from 'slices/booking/cartSlice';
import { useDispatch } from 'react-redux';
import { resetBookingForm } from 'slices/booking/bookingSlice';

function CreateBooking() {

    const dispatch = useDispatch();

    useEffect(() => {
      dispatch(setEditMode(true));
      dispatch(resetBookingForm())
      dispatch(clearCart())
    }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Bookings", link: "/bookings" }, {label: 'Create'}]} />
            <BookingForm/>
      </Container>
    </div>
  )
}

export default CreateBooking
